import {
  CUSTOM_EVENT_COBROWSE_ACTIVE_CONVERSATION_CHANGE,
  CUSTOM_EVENT_COBROWSE_CONVERSATION_STATE_CHANGE,
  EVENT_COBROWSE_REQUEST_PIN, EVENT_COBROWSE_SESSION_ENDED, EVENT_COBROWSE_SESSION_STARTED
} from "@/config/events";
import tracker from 'sanitas-tracking'
import {ApplicationHelper} from "@/helpers/Application";
import {RULES} from "@/config/tracker";
import {COBROWSE_TIME_TO_CLEAR} from "@/config/constants";

export class Cobrowse {

  #api = null;
  #config = null;
  #conversationId = null;
  #eventBus = null;

  constructor(config, eventBus) {
    this.#config = config
    this.#eventBus = eventBus
    this.#checkSession()
  }

  #checkSession() {
    /*
     Keep cookie from last conversation (if not ended properly) for 10 seconds
     for re-entering conversation
     */
    if (this.#getSessionCookie()) {
      window.setTimeout(() => {
        if (this.#conversationId !== this.#getSessionCookie()) {
          this.#removeSessionCookie()
          this.#eventBus.$emit(EVENT_COBROWSE_SESSION_ENDED)
        }
      }, COBROWSE_TIME_TO_CLEAR)
      return this.#init()
    }
    return Promise.resolve()
  }

  async joinConversation(pin, name) {
    if (!this.#api) {
      await this.#init()
    }
    await this.#api.setPersonNickname(name)
    await this.#api.joinConversation(pin)
    this.#eventBus.$emit(EVENT_COBROWSE_SESSION_STARTED)
  }

  startConversation(params) {
    return this.#openConversation(params.cID)
    // return this.#eventBus.$emit(EVENT_COBROWSE_REQUEST_PIN, params)
  }

  async #init() {
    const {url, key, locale} = this.#config
    const scriptUrl = `${url}/unblu/js-api/v2/visitor/visitor-api.min.js`

    await ApplicationHelper.loadScript(scriptUrl)
    this.#api = await this.#configureUnblu(key, url, locale)
    this.#addConversationChangeListener()
  }

  async #openConversation(conversationId) {
    if (!this.#api) {
      await this.#init()
    }
    await this.#api.openConversation(conversationId)
    this.#eventBus.$emit(EVENT_COBROWSE_SESSION_STARTED)
  }

  #addConversationChangeListener() {
    this.#api.on(CUSTOM_EVENT_COBROWSE_ACTIVE_CONVERSATION_CHANGE, conversation => {
      if (conversation) {
        this.#conversationId = conversation.getConversationId()
        conversation.on(CUSTOM_EVENT_COBROWSE_CONVERSATION_STATE_CHANGE, state => {
          if (state === 'ACTIVE') {
            if (this.#getSessionCookie()) {
              tracker.trigger(tracker.triggerType.VIEW_END, RULES.OVP_COBROWSE_PAGE_VIEWED)
            }
            this.#setSessionCookie(this.#conversationId)
          }
        })
      } else {
        if (this.#conversationId) {
          this.#removeSessionCookie()
          this.#eventBus.$emit(EVENT_COBROWSE_SESSION_ENDED)
        }
        this.#conversationId = null
      }
    })
  }

  #configureUnblu = async (key, url, locale) => {
    return await window.unblu.api.configure({
      apiKey: key,
      serverUrl: url,
      locale: locale
    }).initialize();
  }

  #getSessionCookie = () => {
    const m = document.cookie.match(/\bsanitas-cobrowsing-session=([^;]+)/)
    if (m && m[1]) {
      return decodeURIComponent(m[1])
    }
    return undefined
  };

  #setSessionCookie = conversationId => {
    document.cookie = 'sanitas-cobrowsing-session=' + encodeURIComponent(conversationId) + '; path=/;'
  }

  #removeSessionCookie = () => {
    document.cookie = 'sanitas-cobrowsing-session= ; path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT'
  }
}
